<template>
  <div class="bidFileDetail" :style="controlOrderStyle">
    <div class="tabWrap">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="150px"
              :inline="true"
            >
             <el-row>
                <el-col :span="12">
                  <el-form-item label="项目名称">
                    <el-input
                      v-model="dateForm.projectName"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购计划事项">
                    <el-input
                      v-model="dateForm.bidPlanItem"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购计划编号">
                    <el-input
                      v-model="dateForm.bidPlanCode"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目类别">
                    <el-input
                      v-model="dateForm.projectType"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="采购金额">
                    <el-input
                      v-model="dateForm.estimatePrice"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：">
                    <el-input
                      v-model="dateForm.bidPlanMethodValue"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否已取得决策依据">
                    <el-input
                      v-model="dateForm.isDecisionBase"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报单位/部门" prop="commitDeptId">
                    <el-input
                      v-model="dateForm.commitDeptName"
                      placeholder="请选择填报部门"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
               <el-row>
                <el-col :span="12">
                  <el-form-item label="提报单位负责人">
                   <el-input
                      v-model="dateForm.commitResponseUserName"
                      placeholder="请选择提报单位负责人"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经办人">
                   <el-input
                      v-model="dateForm.handlingUserName"
                      placeholder="请选择经办人"
                      readonly
                    ></el-input>
                   
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目情况" prop="approveComment">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dateForm.projectState"
                      style="width: 100%"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提交人">
                    <el-input
                      v-model="dateForm.operateUserName"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="提交时间">
                    <el-input
                      v-model="dateForm.operateTime"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
         <upLoadFileDialog
            :itemVOs="dateForm.attachmentList"
            :itemId="bidFileId"
            :approveStatus="dateForm.status"
            :isUploadAllowed="dateForm.isUploadAllowed"
            :type="approveType"
            @saveUpdateFile="getDetail(bidFileId)"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left"
          class="firstTab"
        >
        <el-row style="margin-top: 10px">
            <el-col :span="2" style="margin-top: 10px; margin-left: 20px">
              审批流类型</el-col
            >
            <el-col :span="8">
              <el-input
                v-model="dateForm.approveTemplateName"
                readonly
              ></el-input>
            </el-col>
          </el-row>
          <div v-if="approveFlag === 'currentApprove'">
            <approveItem
              :itemId="bidFileId"
              :approveType="approveType"
              :subapproveType="subapproveType"
              @finishApprove="close1"
            >
            </approveItem>
          </div>
          <div v-else>
            <approveLine
              :itemId="bidFileId"
              :approveType="approveType"
            ></approveLine>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="集团公司采购办审签单"
          name="seventeen"
          style="text-align: left"
          class="firstTab1"
          v-if="dateForm.status==3"
        >
          <priceOrder
            :itemId="bidFileId"
            :approveType="approveType"
          ></priceOrder>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="info" @click="close1">关 闭</el-button>
    </div>
  </div>
</template>

<script>
import {
  getBidFiledetail, //获取一条采购计划信息
} from "@/services/bidServices";

import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //附件列表
import priceOrder from "./fileOrder"; //控制价审核单
import { goBackApprove } from "@/page/approveComponents/approve";

export default {
  name: "controlOrder",
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
    upLoadFileDialog, //上传附件
    priceOrder, //  审核单情况
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "BID_FILE", //审批类型
      subapproveType: "bidfile", // 审批子类型
      approveFlag: "", //false：查看 true：审批
      planDetailTableData: [],
      bidFileId: null, //存储获取采购计划id
      subServiceContractId: 276, //存储获取采购计划id
      dateForm: {
       id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        commitDeptName: "", //提报部门
        commitDeptId: "", //提报部门
        commitResponseUserName:'', //提报部门负责人名字
        commitResponseUserId:'', //提报部门负责人id
        handlingUserName:'', //经办人名字
        handlingUserId:'', //经办人id
        projectState: "", //项目内容
        bidPlanItem: "", //采购文件事项
        attachmentList: [], //采购文件附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        status: 0, //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "",
        approveTemplateName: "",
        isUploadAllowed: false, //是否允许上传附件标识
      },
      controlOrderStyle: { height: 100 + "%" },
    };
  },
  // created() {
  //   console.log('222222222222222222')
  //   this.currentUserId = sessionStorage.getItem("currentUserId");
  // },
  mounted() {
    let ch3 = document.documentElement.clientHeight - 60;
    this.$set(this.controlOrderStyle, "height", ch3 + "px");

    window.onresize = () => {
      return (() => {
        let ch4 = document.documentElement.clientHeight - 60;
        this.$set(this.controlOrderStyle, "height", ch3 + "px");
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.approveFlag = this.tabRouteParam?.approveFlag ?? "";
      this.bidFileId = this.tabRouteParam.id;
      this.getDetail(this.bidFileId);
    },
    //获取一条采购计划信息
    getDetail(id) {
      let param = {};
      param.bidFileId = id;

      getBidFiledetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = res.data;
            this.dateForm.isDecisionBase =
              this.dateForm.decisionBaseDisplayName;
            this.dateForm.attachmentList = res.data.attachmentList;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    close1() {
      if (this.approveFlag) {
        goBackApprove(this.approveFlag, "bidFileDetail");
        return;
      } else {
        this.bus.$emit("tabClose", "bidFileDetail");
      }

      this.bus.$emit("navMenuChange", {
        routeId: "bidFile",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.bidFileDetail {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
    .Contractfile {
      height: 44px;
      // padding-left: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
    }
  }

  .bottomBtn {
    position: fixed;
    left: 540px;
    width: 800px;
    height: 60px;
    line-height: 60px;
  }
}
/deep/.ApproveItem .bottomBtn {
  bottom: 22px;
  z-index: 10;
  left: 420px;
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.screenPanel {
  text-align: left;
  height: auto;
  padding-bottom: 16px;
  margin-top: 20px;
  border-bottom: 1px solid #e6e6e6;
}

.operatePanel {
  text-align: left;
  margin: 20px 60px;
}

.el-select {
  width: 100%;
}
.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}
/deep/.el-header {
  position: relative;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}
.el-form-item {
  margin-bottom: 14px;
}

.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}
.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}
.right {
  height: 32px;
  line-height: 32px;
  width: 60px;
  text-align: center;
  cursor: pointer;
}
.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}
.el-select {
  margin-right: 10px;
}

/deep/.el-date-editor--time {
  width: 130px;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab1 {
  width: 92%;
}
.firstTab {
  width: 72%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 90%;
  }
  .firstTab1 {
    width: 100%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>

